<template>
  <v-card>
    <v-card-title class="headline">
      Minha avaliação
      <v-btn class="ml-3" small color="primary" to="/minha-empresa">
        Ver mais
      </v-btn>
    </v-card-title>
    <v-card-text class="text--primary">
      <v-icon large color="yellow darken-1">
        mdi-star
      </v-icon>
      <span class="headline ml-3">
        <template v-if="transportador.pessoa.entidade.pontuacaoMediaFrete">
          {{ transportador.pessoa.entidade.pontuacaoMediaFrete | pxSimpleNumber(1) }}
        </template>
        <template v-else>
          Sem avaliação
        </template>
        </span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    transportador: Object,
  },
};
</script>
